import { P as _ } from "./index.es23.js";
import u from "./index.es46.js";
import { __require as c } from "./index.es47.js";
import { __require as p } from "./index.es48.js";
import { i as S } from "./index.es38.js";
var t, s;
function w() {
  if (s) return t;
  s = 1, t = e;
  var n = _, a = u.Writable, f = c().StringDecoder, d = p().Buffer;
  function e(r, o) {
    var i = this._parser = new n(r, o), m = this._decoder = new f();
    a.call(this, { decodeStrings: !1 }), this.once("finish", function() {
      i.end(m.end());
    });
  }
  return S(e, a), e.prototype._write = function(r, o, i) {
    r instanceof d && (r = this._decoder.write(r)), this._parser.write(r), i();
  }, t;
}
export {
  w as __require
};
//# sourceMappingURL=index.es29.js.map
